import Accesses from '@/pages/Reports/Accesses'
import DataChanges from '@/pages/Reports/DataChanges'
import SystemStorage from '@/pages/Reports/SystemStorage'
import LogicStorage from '@/pages/Reports/LogicStorage'
import Notifications from '@/pages/Reports/Notifications'

export default [
  {
    path: '/reports/accesses',
    name: 'Accesses',
    component: Accesses,
    meta: {
      title: 'titles.reports.accesses',
      requiresAuth: true,
      roles: [ 'SUPER_ADMIN', 'GROUP_ADMIN', 'COMPANY_ADMIN' ]
    }
  },
  {
    path: '/reports/data-changes',
    name: 'DataChanges',
    component: DataChanges,
    meta: {
      title: 'titles.reports.dataChanges',
      requiresAuth: true,
      roles: [ 'SUPER_ADMIN', 'GROUP_ADMIN', 'COMPANY_ADMIN' ]
    }
  },
  {
    path: '/reports/system-storage',
    name: 'SystemStorage',
    component: SystemStorage,
    meta: {
      title: 'titles.reports.systemStorage',
      requiresAuth: true,
      roles: [ 'SUPER_ADMIN' ]
    }
  },
  {
    path: '/reports/logic-storage',
    name: 'LogicStorage',
    component: LogicStorage,
    meta: {
      title: 'titles.reports.logicStorage',
      requiresAuth: true,
      roles: [ 'GROUP_ADMIN', 'COMPANY_ADMIN' ]
    }
  },
  {
    path: '/reports/notifications',
    name: 'Notifications',
    component: Notifications,
    meta: {
      title: 'titles.reports.notifications',
      requiresAuth: true,
      roles: [ 'SUPER_ADMIN', 'GROUP_ADMIN', 'COMPANY_ADMIN' ]
    }
  }
]



// WEBPACK FOOTER //
// ./src/pages/Reports/routes.js